export default __webpack_public_path__ + "static/media/gerador-templates-banner.0b47d550.png";